// extracted by mini-css-extract-plugin
export default {"noitems":"ChatRoom_noitems__UjBtx"};